/**
 * IRL Find Evidence — loader stages (one API call; mirrors internal VDR → claim check).
 */

export const IRL_EVIDENCE_PIPELINE_STAGES = [
    {
        id: 'vdr_search',
        label: 'Searching data room',
        durationMs: 2200,
        activeMessages: [
            'Retrieving VDR documents for this workstream…',
            'Answering the diligence question from files…',
        ],
    },
    {
        id: 'claim_check',
        label: 'Checking your response',
        durationMs: 2200,
        activeMessages: [
            'Comparing management response to VDR evidence…',
            'Computing match result…',
        ],
    },
];

export function buildIRLEvidenceStagePlan() {
    return IRL_EVIDENCE_PIPELINE_STAGES.map(s => ({ ...s }));
}

export function pickIRLEvidenceActiveMessage(stage, tick = 0) {
    const msgs = stage?.activeMessages || [stage?.label || 'Working…'];
    return msgs[tick % msgs.length];
}
